<div class="max-w-md w-full space-y-8">

  <div class="flex flex-col items-center">
    <app-fitmed-logo-white [large]="true"></app-fitmed-logo-white>

    <h2 class="account-title">{{ "ForgotPassword" | localizeText : 'Forgot Password' }}</h2>
  </div>

  <form class="mt-8 space-y-3" [formGroup]="forgotPasswordForm" (submit)="submit()">
    <!-- Email -->
    <div>
      <label for="emailAddress" class="sr-only">{{ 'EmailAddress' | localizeText : 'Email Address' }}</label>
      <input id="emailAddress" type="text" placeholder="{{ 'EmailAddress' | localizeText : 'Email Address' }}"
             formControlName="emailAddress"
             class="account-input rounded-t-md sm:text-sm">
    </div>

    <a [routerLink]="loginUrl" class="text-sm font-medium text-white hover:opacity-80 flex items-center justify-end">
      <app-icon [icon]="icons.login"></app-icon>
      <span>{{ 'Login' | localizeText : 'Login' }}</span>
    </a>

    <app-button class="block w-full text-center items-center" type="submit" [loading$]="loading$">
      {{ 'SendResetEmail' | localizeText : 'Send reset email' }}
    </app-button>
  </form>
</div>
